module.exports = __webpack_public_path__ + "static/media/redo.219b0b89.svg";